module.exports = __webpack_public_path__ + "static/media/s7.f6b7729a.jpg";